export const APP_STORE_CONNECT_REPORTING_INTEGRATION_ID =
  '8d7aafe0-46e9-4333-84c1-c993afba170d';
export const APPLE_SEARCH_ADS_REPORTING_INTEGRATION_ID =
  'b76bdf58-356f-49b8-b42d-a35a05ae3fb0';
export const APPLOVIN_ADS_REPORTING_INTEGRATION_ID =
  'bb9e71f1-3d96-4558-877b-054153b34a24';
export const APPLOVIN_MAX_REPORTING_INTEGRATION_ID =
  '911207e9-c915-449b-82a6-d999641b2af2';
export const APPSFLYER_REPORTING_INTEGRATION_ID =
  '43f82348-67ce-4f27-9a0c-a77ed28e0748';
export const GOOGLE_ADS_REPORTING_INTEGRATION_ID =
  '8042f2a8-a766-4997-a553-2e2f674d6272';
export const GOOGLE_ANALYTICS_REPORTING_INTEGRATION_ID =
  'b70b3d3e-c70c-49af-8e04-1b0b73a25f51';
export const GOOGLE_PLAY_CONSOLE_REPORTING_INTEGRATION_ID =
  '18f89e52-2a81-416f-9608-cc5c48751e83';
export const IRON_SOURCE_REPORTING_INTEGRATION_ID =
  '34bef7b3-9ff3-4f19-a653-84914dba1f34';
export const LIFTOFF_REPORTING_INTEGRATION_ID =
  '53169348-3468-4c2a-b67c-fed4afc739d5';
export const MOLOCO_ADS_REPORTING_INTEGRATION_ID =
  'd9fa8143-bb25-4b36-a2d9-123d868a131a';
export const META_ADS_REPORTING_INTEGRATION_ID =
  'a9e1e1d1-f8ad-449e-a47a-31209d3fab66';
export const MINTEGRAL_REPORTING_INTEGRATION_ID =
  '6bc60ff5-9b6c-40cc-bd23-4aac767b614e';
export const PAY_PAL_REPORTING_INTEGRATION_ID =
  '14ae0faa-0d7b-4edd-b29e-3ae82db8c1f5';
export const SNAPCHAT_ADS_REPORTING_INTEGRATION_ID =
  'd9697ac2-dbb9-44bf-9f4f-18a0c7df4560';
export const STRIPE_REPORTING_INTEGRATION_ID =
  '897b714c-4902-42e3-ac67-5451b2f808ef';
export const TAPJOY_REPORTING_INTEGRATION_ID =
  'fbdfb514-4374-44f1-ba4d-af0724827b09';
export const TIK_TOK_FOR_BUSINESS_REPORTING_INTEGRATION_ID =
  'c2caa39c-2f43-4693-a49c-b6902c94859f';
export const UNITY_ADS_REPORTING_INTEGRATION_ID =
  '11f5d130-5f80-4890-a073-fdc13cdd62b2';
export const X_ADS_REPORTING_INTEGRATION_ID =
  'c19f4688-b05d-423a-b229-e32b75e197c6';
export const PINTEREST_REPORTING_INTEGRATION_ID =
  'd97a5ed0-0c4c-43fc-b923-c57362f1d806';
export const MICROSOFT_ADS_REPORTING_INTEGRATION_ID =
  '0573d1bb-1545-4150-a761-7c37eb5bf096';
export const SOLIDGATE_REPORTING_INTEGRATION_ID =
  '00a9a1b7-af81-4b36-be72-2a102d907986';
export const ADJUST_REPORTING_INTEGRATION_ID =
  '764e7a72-f526-4933-9a25-77873de984e8';
export const PADDLE_REPORTING_INTEGRATION_ID =
  '1df43c88-003d-43f9-8bf4-a32239c464e9';
export const VOLUUM_REPORTING_INTEGRATION_ID =
  '85d41454-63a4-4a58-a693-0bf022e715c8';
export const PAY_PRO_REPORTING_INTEGRATION_ID =
  'd814c371-2e69-4e3c-8e9e-c26b697edddf';
export const MERCHANTO_REPORTING_INTEGRATION_ID =
  'b024375e-6e8f-4885-bf6c-73dd02e5d7c4';
export const CUSTOM_REPORTING_INTEGRATION_ID =
  '3a082acf-ee36-4531-8c32-ca31032a086a';
export const PROPELLER_ADS_REPORTING_INTEGRATION_ID =
  'be178e50-c148-42d8-a4df-0d3b6aa2697a';
export const EVERFLOW_REPORTING_INTEGRATION_ID =
  'b7ab902a-cda3-4143-bc7c-263d9f62e4a8';
export const SINGULAR_REPORTING_INTEGRATION_ID =
  '06feb2c9-8853-4e93-a654-a4aec62e7485';
export const IMPACT_REPORTING_INTEGRATION_ID =
  '30a26ff1-dbe2-40ec-9c13-ab221140fa60';
export const BIGO_ADS_REPORTING_INTEGRATION_ID =
  'd82dddfd-4769-464f-abd5-3464159b8f24';
export const CHARGEBEE_REPORTING_INTEGRATION_ID =
  'ede86a6d-9ec0-495d-b897-b8a647e67881';
export const HILLTOP_ADS_REPORTING_INTEGRATION_ID =
  'f5a809e5-231e-4d0c-a413-8579e0623682';
export const TRAFFIC_STARS_REPORTING_INTEGRATION_ID =
  'f52f7c8c-2b67-412c-93aa-ac5e39d825de';
export const TRAFFIC_JUNKY_REPORTING_INTEGRATION_ID =
  '94258bc1-1d6e-4d63-bff3-99ff889d7daf';
export const SCALEO_REPORTING_INTEGRATION_ID =
  'd7a4f499-c930-4154-832d-4b7adc5bc73e';
export const BRANCH_REPORTING_INTEGRATION_ID =
  'f7a80c34-36f5-4f48-ab74-565c016dbf35';
export const REDDIT_REPORTING_INTEGRATION_ID =
  '631ae737-24db-48fc-af0a-f418a07337e7';
export const XSOLLA_REPORTING_INTEGRATION_ID =
  '3f13889b-e058-4aa1-ae6e-549db2157681';
export const AFFISE_REPORTING_INTEGRATION_ID =
  'b9a450fb-38fd-4d05-bc08-80aae39415e6';
export const DISPUTEUR_REPORTING_INTEGRATION_ID =
  '65f28122-9651-48b9-b5d8-32daba279766';
export const REDTRACK_REPORTING_INTEGRATION_ID =
  '419281d0-a7a4-4e96-ab65-f38d71dc8997';
export const FUNNELFOX_REPORTING_INTEGRATION_ID =
  '668c9938-4a59-41ae-beac-f0e60d991375';
export const PRIMER_REPORTING_INTEGRATION_ID =
  'd889925c-0926-45ee-8366-7d3b409bb0be';
export const CHARGEBLAST_REPORTING_INTEGRATION_ID =
  '92ce178e-cd02-483d-919c-7fab9203910e';
export const BRAINTREE_REPORTING_INTEGRATION_ID =
  '541cc086-371a-4035-9991-360692e88872';
export const UNLIMIT_REPORTING_INTEGRATION_ID =
  '7fd3a7dd-9f44-48ff-b55f-5ca3e0ff3588';
export const FUNNELFOX_BILLING_REPORTING_INTEGRATION_ID =
  '611cb2d8-713d-44bd-8229-a13f9761c30a';
export const ANROK_REPORTING_INTEGRATION_ID =
  'af189028-e351-4494-b5b6-7fc12580d921';
export const REVENUE_CAT_BILLING_REPORTING_INTEGRATION_ID =
  'c0c832a3-d212-4ba8-b6e1-cf5a9013a406';
export const SUPERWALL_REPORTING_INTEGRATION_ID =
  '4be98703-a916-4456-b04f-2557b9590254';
export const AIRBRIDGE_REPORTING_INTEGRATION_ID =
  '8ebdb0dc-e8c5-4888-a9bc-630889282258';
export const STICKY_IO_REPORTING_INTEGRATION_ID =
  '694491ea-bd4c-4e7f-b28e-012a337fa3ea';
export const CLICKADU_REPORTING_INTEGRATION_ID =
  '78a4571f-689b-49d0-93d1-c64bbb0ae813';
export const EXOCLICK_REPORTING_INTEGRATION_ID =
  '47735516-92b9-4d22-ad12-8565300741a6';
export const JUICY_ADS_REPORTING_INTEGRATION_ID =
  '213a94b0-9172-442e-80b4-ed026bbeb390';
export const TRUEGATE_REPORTING_INTEGRATION_ID =
  '21408470-89bd-497e-9bcb-bd55543f833b';
export const OPENAI_REPORTING_INTEGRATION_ID =
  '60aa7cab-a17d-4543-9991-2a828f868957';
export const ADSTERRA_REPORTING_INTEGRATION_ID =
  '4efd1152-8e54-4be9-85e9-774de282dd6f';
export const INFLUENCER_HERO_REPORTING_INTEGRATION_ID =
  'dad08cc3-5037-4f9b-8a26-3887cc4c375f';
export const COPS_REPORTING_INTEGRATION_ID =
  'ac65702f-3dc9-4ebc-a9cb-417c1875b419';
export const MOLLIE_REPORTING_INTEGRATION_ID =
  '06d472a0-eed5-4752-ac6d-37c3ef002d09';
export const REVOLUT_REPORTING_INTEGRATION_ID =
  '4aa29e87-6c0d-4f1c-9cd0-ab1bfc57f86b';
